import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { EvaluationsService } from './../../../evaluations/services/evaluations.service';

@Component({
	selector: 'contact-tests',
	templateUrl: './contact-tests.component.html',
	styleUrls: ['./contact-tests.component.scss'],
})
export class ContactTests implements OnInit {
	@Input() contactName;
	@Input() contactId;
	isLoading = true;
	isEvaluationDetailOpen = false;
	selectedEvaluationId = null;
	hasError = false;
	hasData = false;
	evaluations = [];
	itemId = null;

	constructor(
		private evaluationsService: EvaluationsService,
		private route: Location
	) {
		this.itemId = (this.route.getState() as any)?.itemId;
	}

	ngOnInit() {
		this.evaluationsService
			.getEvaluations(this.contactId)
			.toPromise()
			.then((res) => {
				if (res.length === 0) {
					this.hasData = false;
					return;
				}
				this.evaluations = res;
			})
			.catch(() => {
				this.hasError = true;
			})
			.finally(() => {
				this.isLoading = false;
				if (this.itemId) {
					this.openDetail(this.itemId);
				}
			});
	}

	openDetail(evaluationId) {
		this.selectedEvaluationId = evaluationId;
		setTimeout(() => {
			this.isEvaluationDetailOpen = true;
		}, 500);
	}
}
